import React from 'react';
import { formatEncounterDate } from './passportCopy';

export type PassportAchievementItem = {
  public_id: string;
  name: string;
  description?: string;
  template_key: string;
  short_label?: string;
  issued_at?: string;
  hidden?: boolean;
};

type Props = {
  achievements: PassportAchievementItem[];
  onOpen?: (publicId: string) => void;
};

export const PassportAchievementsStrip: React.FC<Props> = ({ achievements, onOpen }) => {
  const visible = achievements.filter((a) => !a.hidden).slice(0, 6);
  if (visible.length === 0) return null;

  return (
    <section className="mb-10" aria-labelledby="passport-achievements-heading">
      <div className="mb-4">
        <h2 id="passport-achievements-heading" className="text-lg font-semibold text-white">
          Recognition
        </h2>
        <p className="mt-1 text-sm text-zinc-500">Milestones from real encounters — not a scoreboard.</p>
      </div>

      <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2.5 list-none">
        {visible.map((a) => (
          <li key={a.public_id}>
            <button
              type="button"
              onClick={() => onOpen?.(a.public_id)}
              className="w-full text-left rounded-xl border border-white/[0.08] bg-[#0c0c0c] px-3.5 py-3 hover:border-white/[0.14] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-amber-400/60"
            >
              <p className="text-sm font-semibold text-white leading-snug">{a.name}</p>
              {a.description ? (
                <p className="mt-1 text-xs text-zinc-500 line-clamp-2">{a.description}</p>
              ) : null}
              {a.issued_at ? (
                <p className="mt-2 text-[11px] text-zinc-600">
                  {formatEncounterDate(a.issued_at)}
                </p>
              ) : null}
            </button>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default PassportAchievementsStrip;
